import RcSteps from "rc-steps";
import type { StepsProps as RcStepsProps } from "rc-steps/lib/Steps";
import type { FC } from "react";
import type { StepIconRender } from "rc-steps/es/Steps";

import checkedIcon from "../../../assets/icons/checked.svg";

import { SvgIcon } from "./SvgIcon";

const prefixCls = "jomo-steps";
const iconPrefix = "jomo";

export const Steps: FC<RcStepsProps & { headerTitle?: string }> = (props) => {
	const { current = 0, headerTitle, ...restProps } = props;

	const icons = {
		finish: <SvgIcon size={20} src={checkedIcon} />,
		// Should never be shown, but necessary to set
		error: <div />
	};

	const stepIconRender: StepIconRender = ({ node, status }) => {
		if (status === "process") {
			return <div className={`${prefixCls}-progress-icon`}>{node}</div>;
		}

		return node;
	};

	return (
		<div className="grid gap-10">
			<div className="text-brand-dark-900 text-2xl font-semibold">{headerTitle}</div>
			<RcSteps
				icons={icons}
				{...restProps}
				current={current}
				size="small"
				stepIcon={stepIconRender}
				direction="vertical"
				prefixCls={prefixCls}
				iconPrefix={iconPrefix}
			/>
		</div>
	);
};
